const Loader = () => {
  return (
    <div style={{ textAlign: "center", alignContent: "center" }}>
      Loading...
    </div>
  );
};

export default Loader;
